import { render, staticRenderFns } from "./DataList.vue?vue&type=template&id=130268df&scoped=true"
import script from "./DataList.vue?vue&type=script&lang=js"
export * from "./DataList.vue?vue&type=script&lang=js"
import style0 from "./DataList.vue?vue&type=style&index=0&id=130268df&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130268df",
  null
  
)

export default component.exports